var _style, _path, _polygon, _polygon2, _path2, _polygon3, _path3, _path4, _path5, _polygon4, _path6, _path7, _rect, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxJump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{fill:#E9E0D3;}\n\t.st2{fill:#F9EFE2;}\n\t.st3{fill:#EF9062;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,182.9c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6S29,63.99,29,106.3 C29,148.6,63.61,182.9,106.3,182.9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "91.34,143.03 59.99,124.48 64.32,74.39 113.79,70.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "153.33,137.65 91.34,143.03 93.07,90.29 142.54,85.99 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.14,102.61L111.11,104c-2.21,0.19-4.16-1.44-4.35-3.65l0,0c-0.19-2.21,1.44-4.16,3.65-4.35l16.03-1.39 c2.21-0.19,4.16,1.44,4.35,3.65v0C130.99,100.47,129.35,102.42,127.14,102.61z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "142.54,85.99 113.79,70.1 64.32,74.39 93.07,90.29 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.35,92.73c0-0.04-0.01-0.08-0.01-0.11C115.35,92.66,115.35,92.7,115.35,92.73L115.35,92.73z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.12,91.16L115.12,91.16c0.02,0.08,0.03,0.17,0.04,0.25C115.15,91.33,115.14,91.25,115.12,91.16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.55,89.14c-0.02-0.07-0.05-0.13-0.07-0.2C114.5,89.01,114.53,89.07,114.55,89.14L114.55,89.14z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "113.62,101.26 113.62,101.26 113.62,101.27 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.33,95.81c0,0.02,0,0.04-0.01,0.07C115.32,95.85,115.32,95.83,115.33,95.81z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.23,103.39L112.23,103.39c-0.26,0.33-0.53,0.66-0.83,0.98C111.69,104.05,111.96,103.72,112.23,103.39z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 102.42,
    transform: "matrix(0.9996 -0.029 0.029 0.9996 -2.9222 3.3176)",
    className: "st5",
    width: 0,
    height: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.08,97.34c-0.01,0.02-0.01,0.04-0.02,0.07C115.07,97.38,115.07,97.36,115.08,97.34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.42,94.27c0,0.01,0,0.02,0,0.03C115.42,94.29,115.42,94.28,115.42,94.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxJump);
export default __webpack_public_path__ + "static/media/Box_jump.f25a686161a0f4cf74cefed10c07694d.svg";
export { ForwardRef as ReactComponent };